'use client';

import { useEffect, useState } from 'react';

import Link from 'next/link';

import { JWTUserData } from '@kit/supabase/types';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@kit/ui/dropdown-menu';
import { Trans } from '@kit/ui/trans';

import pathsConfig from '~/config/paths.config';

import { SiteHeaderAccountSection } from './site-header-account-section';
import pearlStyles from './website-pearl-button.module.css';

export function WebsiteMobileHeaderActions({
  user,
}: {
  user: JWTUserData | null;
}) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const closeOnDesktop = () => {
      if (desktop.matches) setOpen(false);
    };
    closeOnDesktop();
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, []);
  const triggerClass =
    'flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2';
  return (
    <div
      data-mobile-header-actions
      className="order-3 flex items-center gap-1 lg:hidden"
    >
      <SiteHeaderAccountSection user={user} />
      <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
        <DropdownMenuTrigger
          className={triggerClass}
          aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
        >
          <span className="website-menu-icon" aria-hidden>
            <span />
            <span />
            <span />
          </span>
        </DropdownMenuTrigger>
        <DropdownMenuContent data-mobile-menu align="end" sideOffset={14}>
          {[
            ['platform', '/#platform'],
            ['axcelerate', '/axcelerate'],
            ['pricing', '/pricing'],
            ['contact', '/contact'],
          ].map(([label, href]) => (
            <DropdownMenuItem key={label} asChild>
              <Link href={href!}>
                <Trans i18nKey={`marketing:${label}`} />
              </Link>
            </DropdownMenuItem>
          ))}
          <div className="my-2 border-t border-white/20" role="separator" />
          <DropdownMenuItem asChild>
            <Link href="/contact">
              <Trans i18nKey="marketing:home.talkToUs" />
            </Link>
          </DropdownMenuItem>
          {!user && (
            <>
              <DropdownMenuItem asChild>
                <Link href={pathsConfig.auth.signIn}>
                  <Trans i18nKey="auth:signIn" />
                </Link>
              </DropdownMenuItem>
              <div className="my-2 border-t border-white/20" role="separator" />
              <DropdownMenuItem asChild>
                <Link
                  href={pathsConfig.auth.signUp}
                  className={`${pearlStyles.pearl} website-signup-glass`}
                  data-mobile-signup
                >
                  <Trans i18nKey="auth:signUp" />
                </Link>
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
